module.exports = __webpack_public_path__ + "media/svg/vg-fb91e734.svg";